// extracted by mini-css-extract-plugin
export default {"root":"Header_root__BwPMO","dark":"Header_dark__B6zpe","container":"Header_container__CaYGa"};